export const getDomain = (email = "") => email.includes("@") ? email.replace(/.*@/, "") : "";
